import { render, staticRenderFns } from "./uploadTip-editor.vue?vue&type=template&id=781a05e4&scoped=true&"
import script from "./uploadTip-editor.vue?vue&type=script&lang=js&"
export * from "./uploadTip-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781a05e4",
  null
  
)

export default component.exports